import zxcvbn from 'zxcvbn'

interface Props {
	minStrength: number
	thresholdLength: number
	password: string
}

const PasswordMeter: React.FC<Props> = ({ minStrength, thresholdLength, password }) => {
	const strength = zxcvbn(password).score

	const passwordLength = password.length
	// const passwordStrong = strength >= minStrength
	// const passwordLong = passwordLength > thresholdLength

	// const counterClass = [
	// 	'badge badge-pill',
	// 	passwordLong ? (passwordStrong ? 'badge-success' : 'badge-warning') : 'badge-danger',
	// ]
	// 	.join(' ')
	// 	.trim()

	const strengthClass = ['strength-meter mt-2', passwordLength > 0 ? 'visible' : 'invisible']
		.join(' ')
		.trim()

	return (
		<div className={strengthClass}>
			<div className="strength-meter-fill" data-strength={strength}></div>
		</div>
	)
}

export default PasswordMeter
